import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d551987a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExploreMapButton',
  props: {
    onClick: { type: Function },
    disabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["explore-map", {disabled: _ctx.disabled}]),
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_unref(Icon), {
      "icon-name": "mapIcon",
      class: "map-icon"
    }),
    _createTextVNode(" " + _toDisplayString(_ctx.$t("Explore map")), 1)
  ], 10, _hoisted_1))
}
}

})